<div class="loading-container">
  <mat-spinner></mat-spinner>
  <p>{{ text }}</p>
</div>
